import { getUserIdList } from '../../../api';
import { wrapRequestArea } from '../../../lib/http/lib';
import { IUserListItem } from '../../../model/api-modules';

export const transformWoaUsersToOtherSitePic = async (
  userIDs: string[],
  site: string
) => {
  const siteUserList = await wrapRequestArea(getUserIdList, site);

  return transformUserIDsToPic(userIDs, siteUserList);
};

export const transformUserIDsToPic = (
  userIDs: string[],
  siteUsers: IUserListItem[]
) => {
  const siteUserList = siteUsers;
  if (!siteUserList?.length) {
    return '';
  }

  const getSitePic = (userIDs: string[]) =>
    userIDs
      .map((userID) => siteUserList.find((item) => item.UserID === userID)?.id)
      .filter(Boolean)
      .join();

  return getSitePic(userIDs) || getSitePic(['tatiwang@tencent.com']) || '';
};

export const getServiceConfigOptions = () => {
  return {
    Business: [
      { value: 'g6', label: 'InGame' },
      {
        value: 'currency',
        label: 'Currency',
      },
      {
        value: 'gcloud',
        label: 'GCloud',
      },
      {
        value: 'bianque',
        label: 'Bianque',
      },
      {
        value: 'dmp',
        label: 'DMP',
      },
    ],
    SupportType: [
      {
        value: 'iframe',
        label: 'Iframe',
      },
      { value: 'jump', label: 'Jump' },
    ],
    ParentName: [
      {
        value: 'Multiplayer',
        label: 'Multiplayer',
      },
      {
        value: 'Social',
        label: 'Social',
      },
      {
        value: 'Economy',
        label: 'Economy',
      },
      {
        value: 'Engagement',
        label: 'Engagement',
      },
      {
        value: 'Analytics',
        label: 'Analytics',
      },
      {
        value: 'Content',
        label: 'Content',
      },
    ],
  };
};
